import CrmOrderDetails from '../../CrmOrderDetails';

const RaApiOrderMapperV1 = {
  mapJsonToOrderDetails: (parsedOrderJson) => new CrmOrderDetails(
    parsedOrderJson.id,
    parsedOrderJson.createdAt,
    parsedOrderJson.orderNumber,
    parsedOrderJson.grandTotal,
    parsedOrderJson.shippingTimestamp,
    parsedOrderJson.shippingStatus,
    parsedOrderJson.poNumber,
    parsedOrderJson.paymentStatus,
    parsedOrderJson.shipmentList ? parsedOrderJson.shipmentList : [],
    parsedOrderJson.shippingAddress,
    parsedOrderJson.billingAddress,
    parsedOrderJson.tax,
    parsedOrderJson.shippingAmount,
    parsedOrderJson.orderLineItemList ? parsedOrderJson.orderLineItemList : [],
    parsedOrderJson.paymentBalanceDue,
    parsedOrderJson.currency,
    parsedOrderJson.shipMethod,
    parsedOrderJson.shipCarrier,
    parsedOrderJson.crmOrgId,
    parsedOrderJson.referrerCode,

  ),
};

export default RaApiOrderMapperV1;
